import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Selectors
import { AppSelectors } from 'app/shared/selectors';

// style
import './style.scss';

const propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isScreenXS: PropTypes.bool.isRequired,
    isScreenSM: PropTypes.bool.isRequired,
};

const ViewTourModal = ({
    src,
    title,
    isScreenXS,
    isScreenSM,
}) => {
    const isFullHeight = isScreenXS || isScreenSM;
    let height = '700px';
    // Needed because sphere-viewer doesn't handle properly height 100% or 100vh.
    if (typeof window !== 'undefined' && isFullHeight) {
        // 45 corresponds to the modal header height
        const innerHeight = window.innerHeight - 45;
        height = `${innerHeight}px`;
    }
    return (
        <iframe width="100%" height={height} title={title} src={src} />
    );
};

const mapStateToProps = state => ({
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
});

ViewTourModal.propTypes = propTypes;

export { ViewTourModal };
export default connect(mapStateToProps)(ViewTourModal);
